/** NOTE: will probably look into using 'normalizr' */
import keyBy from 'lodash/keyBy';
import capitalize from 'lodash/capitalize';

export const normalize = (payload, keyByProperty = 'id') => {
  const keyByName = `By${capitalize(keyByProperty)}`;
  const entries = Object.entries(payload);

  const result = entries.reduce((acc, [key, value]): any => {
    acc[key] = value;
    const val = Array.isArray(value) ? value : [value];

    acc[`${key}${keyByName}`] = keyBy(val, keyByProperty);

    return acc;
  }, {});

  return result;
};

export const resolve = (state, { data, keyByProperty, ...options }) => {
  if (options?.setValue) {
    return options.setValue(state, data);
  }

  return keyByProperty === null ? data : normalize(data, keyByProperty);
};

export const parseLoggerType = (type: string) => {
  const originalType = !type.includes(' ') ? type : type.split(' ')[1];
  return originalType;
};

export const handleCustomType = (EntityActionType, logAs) => {
  const customType = {
    type: logAs
      ? `[${logAs.toUpperCase()}] ${EntityActionType.REQUEST_IN_FLIGHT}`
      : EntityActionType.REQUEST_IN_FLIGHT
  };
  return customType;
};
